<app-custom-breadcrumb [crumbs]="breadcrumbs" xmlns="http://www.w3.org/1999/html"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2>{{fleetId ? 'Edit Vehicle Details - ' : 'Add New Vehicle'}}{{fleetId ? fleetInfo?.vehicleDetails?.registrationNumber : ''}}</h2>
</div>

<!--form section-->
<section [ngClass]="!loading ? 'block' : 'hidden'">
  <nz-card>
    <div>
      <h5 class="text-primary">General Information</h5>
      <div class="flex justify-between items-center my-3">
        <h6>Vehicle Images</h6>
        <div>
          <nz-upload [nzCustomRequest]="vehicleImageUpload" [nzShowUploadList]="false" [nzMultiple]="true">
            <button nz-button class="outline-button">Upload Images</button>
          </nz-upload>
        </div>
      </div>
      <div class="flex flex-wrap gap-4">
        <div *ngIf="!vehicleImgUploadFiles.length"
             class="relative w-[100px] h-[60px] lg:w-[160px] lg:h-[120px]">
          <img class="object-cover w-[100px] h-[60px] lg:w-[160px] lg:h-[120px]"
               src="{{imgUploadPlaceholder}}" alt=""/>
        </div>

        <div *ngFor="let file of vehicleImgUploadFiles; let i = index"
             class="relative w-[100px] h-[60px] lg:w-[160px] lg:h-[120px]">
          <img nz-image class="object-cover w-[100px] h-[60px] lg:w-[160px] lg:h-[120px]"
               nzSrc="{{file}}" alt=""/>
          <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                (click)="removeUploadFile(i, 'general')" class="absolute top-2 right-2 cursor-pointer"
                style="font-size: 20px;"></span>
          <nz-tag *ngIf="i === 0" [nzColor]="'#3ab200'"
                  class="rounded-full text-[6px]/[8px] min-[450px]:text-[6px]/[10px] lg:text-xs xl:text-base absolute left-2 top-3 xl:top-1.5">
            Featured Image
          </nz-tag>
        </div>
        <div *ngIf="vehicleImgUploading" class="flex justify-center items-center">
          <p class="text-primary">Uploading...</p>
        </div>
      </div>

      <nz-divider></nz-divider>

      <div class="grid xl:grid-cols-2">
        <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
          <div formGroupName="generalInfo">
            <div class="grid sm:grid-cols-2 gap-2">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="vehicleType" nzRequired>Vehicle Type</nz-form-label>
                <nz-form-control [nzErrorTip]="vehicleTypeError">
                  <nz-select formControlName="vehicleType" nzPlaceHolder="Select Vehicle Type">
                    <nz-option nzValue="SR" nzLabel="SR"></nz-option>
                    <nz-option nzValue="RENT" nzLabel="Rented Vehicle"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #vehicleTypeError>
                  <span *ngIf="formErrors.generalInfo.vehicleType.required">Please select type. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="vehicleCategory" nzRequired>Vehicle Category</nz-form-label>
                <nz-form-control [nzErrorTip]="vehicleCategoryError">
                  <nz-select formControlName="vehicleCategory" nzPlaceHolder="Select Vehicle Category">
                    <nz-option *ngFor="let data of vehicleCat" [nzValue]="data._id" [nzLabel]="data.name"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #vehicleCategoryError>
                  <span *ngIf="formErrors.generalInfo.vehicleCategory.required">Please select category. </span>
                </ng-template>
              </nz-form-item>
            </div>

            <div *ngIf="vehicleCatCode?.applicableRentCodes?.length || vehicleCatCode?.applicableTransferCodes?.length">
              <h6 class="my-2">Select Vehicle Sub Category Code</h6>
              <nz-form-item *ngIf="vehicleCatCode?.applicableRentCodes.length">
                <nz-form-label>Rent a Car Code</nz-form-label>
                <nz-checkbox-group nzDisabled formControlName="rentCarCode"></nz-checkbox-group>
              </nz-form-item>
              <nz-form-item *ngIf="vehicleCatCode?.applicableTransferCodes.length">
                <nz-form-label>Transfer Code</nz-form-label>
                <nz-checkbox-group nzDisabled formControlName="transferCode"></nz-checkbox-group>
              </nz-form-item>
            </div>
          </div>
        </form>

      </div>
    </div>


    <div *ngIf="fleetForm.get('generalInfo').get('vehicleType').value && !sectionHideByVehicleType" class="mt-10">
      <h5 class="text-primary my-4">Ownership Details</h5>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="ownerInfo">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="ownerName" nzRequired>Full Name of Owner/Company</nz-form-label>
            <nz-form-control [nzErrorTip]="ownerNameError">
              <input nz-input type="text" formControlName="ownerName" placeholder="Enter Name"/>
            </nz-form-control>
            <ng-template #ownerNameError>
              <span *ngIf="formErrors.ownerInfo.ownerName.required">Please enter name. </span>
              <span *ngIf="formErrors.ownerInfo.ownerName.maxlength">Maximum 70 letters only. </span>
              <span *ngIf="formErrors.ownerInfo.ownerName.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="contactPerson" nzRequired>Contact Person</nz-form-label>
            <nz-form-control [nzErrorTip]="contactPersonError">
              <input nz-input type="text" formControlName="contactPerson" placeholder="Enter Contact Person"/>
            </nz-form-control>
            <ng-template #contactPersonError>
              <span *ngIf="formErrors.ownerInfo.contactPerson.required">Please enter contact person. </span>
              <span *ngIf="formErrors.ownerInfo.contactPerson.maxlength">Maximum 70 letters only. </span>
              <span *ngIf="formErrors.ownerInfo.contactPerson.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="contactNumber" nzRequired>Contact Number</nz-form-label>
            <nz-form-control [nzErrorTip]="contactNumberError">
              <nz-select nzMode="tags" nzPlacement="topLeft" formControlName="contactNumber"
                         nzPlaceHolder="Enter Contact Number"></nz-select>
            </nz-form-control>
            <ng-template #contactNumberError>
              <span *ngIf="formErrors.ownerInfo.contactNumber.required">Please enter number. </span>
              <span *ngIf="formErrors.ownerInfo.contactNumber.maxlength">Maximum 10 letters only for one tag. </span>
              <span *ngIf="formErrors.ownerInfo.contactNumber.pattern">Only allowed numbers, please avoid adding special characters or letters. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="contactEmail">Email</nz-form-label>
            <nz-form-control [nzErrorTip]="emailError">
              <input nz-input type="text" formControlName="contactEmail" placeholder="Enter Email"/>
            </nz-form-control>
            <ng-template #emailError>
              <span *ngIf="formErrors.ownerInfo.contactEmail.email">Email is invalid</span>
            </ng-template>
          </nz-form-item>
        </div>
      </form>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 gap-2" formGroupName="ownerInfo">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="permanentAddress" nzRequired>Permanent Address</nz-form-label>
            <nz-form-control [nzErrorTip]="permanentAddressError">
              <textarea nz-input formControlName="permanentAddress" placeholder="Enter Permanent Address"
                        [nzAutosize]="{ minRows: 3, maxRows: 10 }"></textarea>
            </nz-form-control>
            <ng-template #permanentAddressError>
              <span *ngIf="formErrors.ownerInfo.permanentAddress.required">Please enter address. </span>
              <span *ngIf="formErrors.ownerInfo.permanentAddress.maxlength">Maximum 70 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="currentAddress" nzRequired>Current Address</nz-form-label>
            <nz-form-control [nzErrorTip]="currentAddressError">
              <textarea nz-input formControlName="currentAddress" placeholder="Enter Current Address"
                        [nzAutosize]="{ minRows: 3, maxRows: 10 }"></textarea>
            </nz-form-control>
            <ng-template #currentAddressError>
              <span *ngIf="formErrors.ownerInfo.currentAddress.required">Please enter address. </span>
              <span *ngIf="formErrors.ownerInfo.currentAddress.maxlength">Maximum 70 letters only. </span>
            </ng-template>
          </nz-form-item>
        </div>
      </form>
      <h6 class="my-2">National Identity Card/ Passport/ Business Registration Information</h6>
      <div class="grid xl:grid-cols-2 gap-2">
        <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
          <div class="grid sm:grid-cols-2 gap-2" formGroupName="ownerInfo">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="registrationNumber" nzRequired>Registration Number</nz-form-label>
              <nz-form-control [nzErrorTip]="registrationNumberError">
                <input nz-input type="text" formControlName="registrationNumber"
                       placeholder="Enter Registration Number"/>
              </nz-form-control>
              <ng-template #registrationNumberError>
                <span *ngIf="formErrors.ownerInfo.registrationNumber.required">Please enter registration number. </span>
                <span *ngIf="formErrors.ownerInfo.registrationNumber.maxlength">Maximum 30 letters only. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="issuedDate" nzRequired>Date of Issue</nz-form-label>
              <nz-form-control [nzErrorTip]="issuedDateError">
                <nz-date-picker class="w-full" formControlName="issuedDate" [nzDisabledDate]="latestServiceDisabledDate"
                                nzPlaceHolder="Select Date"></nz-date-picker>
              </nz-form-control>
              <ng-template #issuedDateError>
                <span *ngIf="formErrors.ownerInfo.issuedDate.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
          </div>
        </form>
        <div>
          <h6 class="mb-2">Attachments</h6>
<!--          <div class="mb-2">Bank Details</div>-->
<!--          <div class="mb-2">Copy of Vehicle Book</div>-->
          <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
            <div>
              <nz-upload
                [nzCustomRequest]="vehicleBookUpload" [nzShowUploadList]="false" [nzMultiple]="true"
                class="">
                <button nz-button>
                  <span nz-icon nzType="upload"></span>
                  Click to Upload
                </button>
              </nz-upload>
            </div>
            <div>
              <p *ngIf="vehicleBookUploading" class="text-primary my-2">Uploading...</p>
            </div>
            <div class="mt-2 overflow-auto">
              <div *ngFor="let file of vehicleBookUploadFile; let i = index"
                   class="flex justify-between items-center mx-3 gap-5">
                <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                      class="cursor-pointer" nz-popconfirm
                      nzPopconfirmTitle="Are you sure you want to delete this attachment"
                      (nzOnConfirm)="removeUploadFile(i, 'owner')"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="fleetForm.get('generalInfo').get('vehicleType').value" class="mt-10">
      <h5 class="text-primary my-4">Vehicle Details</h5>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="vehicleInfo">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="vehicleBrand" nzRequired>Vehicle Brand</nz-form-label>
            <nz-form-control [nzErrorTip]="vehicleBrandError">
              <nz-select nzShowSearch class="w-full" formControlName="vehicleBrand" nzPlaceHolder="Select Vehicle Brand">
                <nz-option *ngFor="let op of vehicleBrandType" [nzValue]="op.value" [nzLabel]="op.label"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #vehicleBrandError>
              <span *ngIf="formErrors.vehicleInfo.vehicleBrand.required">Please select brand. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="vehicleModel" nzRequired>Vehicle Model</nz-form-label>
            <nz-form-control [nzErrorTip]="vehicleModelError">
              <input nz-input type="text" formControlName="vehicleModel" placeholder="Enter Vehicle Model"/>
            </nz-form-control>
            <ng-template #vehicleModelError>
              <span *ngIf="formErrors.vehicleInfo.vehicleModel.required">Please enter model. </span>
              <span *ngIf="formErrors.vehicleInfo.vehicleModel.maxlength">Maximum 15 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="engineNumber">Engine Number</nz-form-label>
            <nz-form-control [nzErrorTip]="engineNumberError">
              <input nz-input type="text" formControlName="engineNumber" placeholder="Enter Engine Number"/>
            </nz-form-control>
            <ng-template #engineNumberError>
              <span *ngIf="formErrors.vehicleInfo.engineNumber.maxlength">Maximum 20 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="chassisNumber">Chassis Number</nz-form-label>
            <nz-form-control [nzErrorTip]="chassisNumberError">
              <input nz-input type="text" formControlName="chassisNumber" placeholder="Enter Chassis Number"/>
            </nz-form-control>
            <ng-template #chassisNumberError>
              <span *ngIf="formErrors.vehicleInfo.chassisNumber.maxlength">Maximum 20 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="fuelType" nzRequired>Fuel Type</nz-form-label>
            <nz-form-control [nzErrorTip]="fuelTypeError">
              <nz-select class="w-full" formControlName="fuelType" nzPlaceHolder="Select Fuel Type">
                <nz-option *ngFor="let op of fuelType" [nzValue]="op.value" [nzLabel]="op.label"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #fuelTypeError>
              <span *ngIf="formErrors.vehicleInfo.fuelType.required">Please select fuel type. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="transmission" nzRequired>Transmission</nz-form-label>
            <nz-form-control [nzErrorTip]="transmissionError">
              <nz-select class="w-full" formControlName="transmission" nzPlaceHolder="Select Transmission">
                <nz-option *ngFor="let op of transmissionType" [nzValue]="op.value" [nzLabel]="op.label"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #transmissionError>
              <span *ngIf="formErrors.vehicleInfo.transmission.required">Please select transmission. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzRequired>Year of Manufacture</nz-form-label>
            <nz-form-control [nzErrorTip]="manufactureDateError">
              <nz-date-picker nzMode="year" [nzDisabledDate]="latestServiceDisabledDate" formControlName="manufactureDate" class="w-full"></nz-date-picker>
            </nz-form-control>
            <ng-template #manufactureDateError>
              <span *ngIf="formErrors.vehicleInfo.manufactureDate.required">Please select date. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label>Year of Register</nz-form-label>
            <nz-date-picker nzMode="year" [nzDisabledDate]="latestServiceDisabledDate" formControlName="registerDate" class="w-full"></nz-date-picker>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="seatsNumber" nzRequired>No of Seats</nz-form-label>
            <nz-form-control [nzErrorTip]="seatsNumberError">
              <input nz-input type="number" formControlName="seatsNumber" placeholder="Enter No of Seats"/>
            </nz-form-control>
            <ng-template #seatsNumberError>
              <span *ngIf="formErrors.vehicleInfo.seatsNumber.required">Please enter value. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="registrationNumber" nzRequired>Registration Number</nz-form-label>
            <nz-form-control [nzErrorTip]="registrationNumberError">
              <input nz-input type="text" formControlName="registrationNumber" placeholder="Enter Registration Number"/>
            </nz-form-control>
            <ng-template #registrationNumberError>
              <span *ngIf="formErrors.vehicleInfo.registrationNumber.required">Please enter number. </span>
              <span *ngIf="formErrors.vehicleInfo.registrationNumber.maxlength">Maximum 15 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="color" nzRequired>Color</nz-form-label>
            <nz-form-control [nzErrorTip]="colorError">
              <input nz-input type="text" formControlName="color" placeholder="Enter Color"/>
            </nz-form-control>
            <ng-template #colorError>
              <span *ngIf="formErrors.vehicleInfo.color.required">Please enter color. </span>
              <span *ngIf="formErrors.vehicleInfo.color.maxlength">Maximum 70 letters only. </span>
              <span *ngIf="formErrors.vehicleInfo.color.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
            </ng-template>
          </nz-form-item>

<!--          <nz-form-item class="grid grid-flow-row content-start">-->
<!--            <nz-form-label nzFor="color" nzRequired>License Plate</nz-form-label>-->
<!--            <nz-form-control [nzErrorTip]="colorError">-->
<!--              <input nz-input type="text" formControlName="LicensePlate" placeholder="Enter License Plate"/>-->
<!--            </nz-form-control>-->
<!--            <ng-template #colorError>-->
<!--              <span *ngIf="formErrors.vehicleInfo.color.required">Please enter License Plate. </span>-->
<!--              <span *ngIf="formErrors.vehicleInfo.color.maxlength">Maximum 70 letters only. </span>-->
<!--              <span *ngIf="formErrors.vehicleInfo.color.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>-->
<!--            </ng-template>-->
<!--          </nz-form-item>-->

        </div>
      </form>
    </div>

    <div *ngIf="fleetForm.get('generalInfo').get('vehicleType').value && !sectionHideByVehicleType" class="mt-10">
      <h5 class="text-primary my-4">Agreement Details</h5>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div formGroupName="agreementInfo">
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="MonthRentalAmount" nzRequired>Monthly Rental Amount</nz-form-label>
              <nz-form-control [nzErrorTip]="MonthRentalAmountError">
                <nz-input-number
                  class="w-full"
                  formControlName="MonthRentalAmount"
                  nzPlaceHolder="Enter Amount"
                  [nzMin]="0"
                  [nzStep]="1"
                  [nzFormatter]="formatterCurrencyMonthRent"
                  [nzParser]="parserCurrencyMonthRent"
                ></nz-input-number>
              </nz-form-control>
              <ng-template #MonthRentalAmountError>
                <span *ngIf="formErrors.agreementInfo.MonthRentalAmount.required">Please enter amount. </span>
                <span *ngIf="formErrors.agreementInfo.MonthRentalAmount.maxlength">Maximum 70 letters only. </span>
                <span *ngIf="formErrors.agreementInfo.MonthRentalAmount.pattern">Only allowed Numbers, please avoid adding special characters or letters. </span>
              </ng-template>
            </nz-form-item>
          </div>
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="rentingPeriod" nzRequired>Renting Period</nz-form-label>
              <nz-form-control [nzErrorTip]="rentingPeriodError">
                <nz-select class="w-full" formControlName="rentingPeriod"
                           nzPlaceHolder="Select Period">
                  <nz-option *ngFor="let op of agreementRentingPeriodOptions" [nzValue]="op.value" [nzLabel]="op.label"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #rentingPeriodError>
                <span *ngIf="formErrors.agreementInfo.rentingPeriod.required">Please select period. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item *ngIf="isRentingPeriodOther" class="grid grid-flow-row content-start">
              <nz-form-label nzFor="rentingPeriodOther" nzRequired>Renting Period - Other (Months)</nz-form-label>
              <nz-form-control [nzErrorTip]="rentingPeriodOtherError">
                <input nz-input type="number" formControlName="rentingPeriodOther" placeholder="Enter Other Option"/>
              </nz-form-control>
              <ng-template #rentingPeriodOtherError>
                <span *ngIf="formErrors.agreementInfo.rentingPeriodOther.required">Please enter period. </span>
              </ng-template>
            </nz-form-item>
          </div>
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="entitledKM" nzRequired>Entitled KM's</nz-form-label>
              <nz-form-control [nzErrorTip]="entitledKMError">
                <nz-select class="w-full" formControlName="entitledKMS"
                           nzPlaceHolder="Select Period">
                  <nz-option *ngFor="let op of agreementEntitledKmsOptions" [nzValue]="op.value" [nzLabel]="op.label"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #entitledKMError>
                <span *ngIf="formErrors.agreementInfo.entitledKM.required">Please select option. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item *ngIf="isEntitledKMSOther" class="grid grid-flow-row content-start">
              <nz-form-label nzFor="entitledKMOther" nzRequired>Entitled KM's - Other</nz-form-label>
              <nz-form-control [nzErrorTip]="entitledKMOtherError">
                <nz-input-group nzAddOnAfter="Km">
                  <input nz-input type="number" [min]="0" [step]="1" formControlName="entitledKMOther" placeholder="Enter Other Option"/>
                </nz-input-group>
<!--                <nz-input-number-->
<!--                  class="w-full"-->
<!--                  formControlName="entitledKMOther"-->
<!--                  nzPlaceHolder="Enter Other Option"-->
<!--                  [nzMin]="0"-->
<!--                  [nzStep]="1"-->
<!--                  [nzFormatter]="formatterDistance"-->
<!--                  [nzParser]="parserDistance"-->
<!--                ></nz-input-number>-->
              </nz-form-control>
              <ng-template #entitledKMOtherError>
                <span *ngIf="formErrors.agreementInfo.entitledKMOther.required">Please enter other option. </span>
              </ng-template>
            </nz-form-item>
          </div>
          <div *ngIf="isEntitledKMSPrice" class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="amount" nzRequired>Amount per exceeded mile</nz-form-label>
              <nz-form-control [nzErrorTip]="amountError">
                <nz-input-number
                  class="w-full"
                  formControlName="amount"
                  nzPlaceHolder="Enter Amount"
                  [nzMin]="0"
                  [nzStep]="1"
                  [nzFormatter]="formatterCurrencyMonthRent"
                  [nzParser]="parserCurrencyMonthRent"
                ></nz-input-number>
              </nz-form-control>
              <ng-template #amountError>
                <span *ngIf="formErrors.agreementInfo.amount.required">Please enter amount. </span>
                <span *ngIf="formErrors.agreementInfo.amount.maxlength">Maximum 70 letters only. </span>
                <span *ngIf="formErrors.agreementInfo.amount.pattern">Only allowed Numbers, please avoid adding special characters or letters. </span>
              </ng-template>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>


    <div *ngIf="fleetForm.get('generalInfo').get('vehicleType').value" class="mt-10">
      <h5 class="text-primary my-4">Vehicle Inventory</h5>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="vehicleInventoryInfo">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="odometer" nzRequired>Original Odometer</nz-form-label>
            <nz-form-control [nzErrorTip]="odometerError">
              <nz-input-group nzAddOnAfter="Km">
                <input nz-input type="number" [min]="0" [step]="1" formControlName="odometer" placeholder="Enter Odometer Reading"/>
              </nz-input-group>
<!--              <nz-input-number-->
<!--                class="w-full"-->
<!--                formControlName="odometer"-->
<!--                nzPlaceHolder="Enter Odometer Reading"-->
<!--                [nzMin]="0"-->
<!--                [nzStep]="1"-->
<!--                [nzFormatter]="formatterDistance"-->
<!--                [nzParser]="parserDistance"-->
<!--              ></nz-input-number>-->
            </nz-form-control>
            <ng-template #odometerError>
              <span *ngIf="formErrors.vehicleInventoryInfo.odometer.required">Please enter odometer. </span>
              <span *ngIf="formErrors.vehicleInventoryInfo.odometer.maxlength">Maximum 15 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="fuelLevel" nzRequired>Fuel Level</nz-form-label>
            <nz-form-control [nzErrorTip]="fuelLevelError">
              <nz-input-group nzAddOnAfter="%">
                <input nz-input type="number" [min]="0" [max]="100" [step]="1" formControlName="fuelLevel" placeholder="Enter Fuel Gage Reading"/>
              </nz-input-group>
<!--              <nz-input-number-->
<!--                class="w-full"-->
<!--                formControlName="fuelLevel"-->
<!--                nzPlaceHolder="Enter Fuel Gage Reading"-->
<!--                [nzMin]="0"-->
<!--                [nzMax]="100"-->
<!--                [nzStep]="1"-->
<!--                [nzFormatter]="formatterPercentFuel"-->
<!--                [nzParser]="parserPercentFuel"-->
<!--              ></nz-input-number>-->
              <!--              <input nz-input type="text" formControlName="fuelLevel" placeholder="Enter Fuel Gage Reading"/>-->
            </nz-form-control>
            <ng-template #fuelLevelError>
              <span *ngIf="formErrors.vehicleInventoryInfo.fuelLevel.required">Please enter level. </span>
              <span *ngIf="formErrors.vehicleInventoryInfo.fuelLevel.maxlength">Maximum 15 letters only. </span>
            </ng-template>
          </nz-form-item>
        </div>
      </form>

      <nz-divider></nz-divider>

      <h6 class="my-2">Service Information</h6>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="vehicleInventoryInfo">
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="latestServiceDate" nzRequired>Last Service Date</nz-form-label>
            <nz-form-control [nzErrorTip]="latestServiceDateError">
              <nz-date-picker [nzDisabledDate]="latestServiceDisabledDate" formControlName="latestServiceDate"
                              class="w-full"></nz-date-picker>
            </nz-form-control>
            <ng-template #latestServiceDateError>
              <span *ngIf="formErrors.vehicleInventoryInfo.latestServiceDate.required">Please select date. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="latestServiceMileage" nzRequired>Last Service Mileage</nz-form-label>
            <nz-form-control [nzErrorTip]="latestServiceMileageError">
              <nz-input-group nzAddOnAfter="Km">
                <input nz-input type="number" [min]="0" [step]="1" formControlName="latestServiceMileage" placeholder="Enter Last Service Mileage"/>
              </nz-input-group>
<!--              <nz-input-number-->
<!--                class="w-full"-->
<!--                formControlName="latestServiceMileage"-->
<!--                nzPlaceHolder="Enter Last Service Mileage"-->
<!--                [nzMin]="0"-->
<!--                [nzStep]="1"-->
<!--                [nzFormatter]="formatterDistance"-->
<!--                [nzParser]="parserDistance"-->
<!--              ></nz-input-number>-->
<!--              <input nz-input type="number" formControlName="latestServiceMileage"-->
<!--                     placeholder="Enter Last Service Mileage"/>-->
            </nz-form-control>
            <ng-template #latestServiceMileageError>
              <span *ngIf="formErrors.vehicleInventoryInfo.latestServiceMileage.required">Please enter mileage. </span>
              <span
                *ngIf="formErrors.vehicleInventoryInfo.latestServiceMileage.maxlength">Maximum 15 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="serviceDuration" nzRequired>Service Duration (5'000km/10'000km)</nz-form-label>
            <nz-form-control [nzErrorTip]="serviceDurationError">
              <nz-input-group nzAddOnAfter="Km">
                <input nz-input type="number" [min]="5000" [max]="10000" [step]="1" formControlName="serviceDuration" placeholder="Enter Service Duration"/>
              </nz-input-group>
<!--              <nz-input-number-->
<!--                class="w-full"-->
<!--                formControlName="serviceDuration"-->
<!--                nzPlaceHolder="Enter Service Duration"-->
<!--                [nzMin]="5000"-->
<!--                [nzMax]="10000"-->
<!--                [nzStep]="1"-->
<!--                [nzFormatter]="formatterDistance"-->
<!--                [nzParser]="parserDistance"-->
<!--              ></nz-input-number>-->
<!--              <input nz-input type="number" min="5000" max="10000" formControlName="serviceDuration"-->
<!--                     placeholder="Enter Service Duration"/>-->
            </nz-form-control>
            <ng-template #serviceDurationError>
              <span *ngIf="formErrors.vehicleInventoryInfo.serviceDuration.required">Please enter duration. </span>
              <span *ngIf="formErrors.vehicleInventoryInfo.serviceDuration.min">Minimum value is 5000. </span>
              <span *ngIf="formErrors.vehicleInventoryInfo.serviceDuration.max">Maximum value is 10000. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="serviceResponsible" nzRequired>Service will be done by?</nz-form-label>
            <nz-form-control [nzErrorTip]="serviceResponsibleError">
              <nz-select class="w-full" formControlName="serviceResponsible"
                         nzPlaceHolder="Select Who Will Be">
                <nz-option nzValue="SR" nzLabel="SR"></nz-option>
                <nz-option nzValue="OWNER" nzLabel="Vehicle Owner"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #serviceResponsibleError>
              <span *ngIf="formErrors.vehicleInventoryInfo.serviceResponsible.required">Please select value. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="serviceOilChangeResponsible" nzRequired>Service oil change will be done by?
            </nz-form-label>
            <nz-form-control [nzErrorTip]="serviceOilChangeResponsibleError">
              <nz-select class="w-full" formControlName="serviceOilChangeResponsible"
                         nzPlaceHolder="Select Who Will Be">
                <nz-option nzValue="SR" nzLabel="SR"></nz-option>
                <nz-option nzValue="OWNER" nzLabel="Vehicle Owner"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #serviceOilChangeResponsibleError>
              <span
                *ngIf="formErrors.vehicleInventoryInfo.serviceOilChangeResponsible.required">Please select value. </span>
            </ng-template>
          </nz-form-item>
        </div>
      </form>
      <h6 class="my-2">Transmission Oil Change Information</h6>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="vehicleInventoryInfo">
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="latestOilChangeDate" nzRequired>Last Oil Change Date</nz-form-label>
            <nz-form-control [nzErrorTip]="latestOilChangeDateError">
              <nz-date-picker [nzDisabledDate]="latestServiceDisabledDate" formControlName="latestOilChangeDate" class="w-full"></nz-date-picker>
            </nz-form-control>
            <ng-template #latestOilChangeDateError>
              <span *ngIf="formErrors.vehicleInventoryInfo.latestOilChangeDate.required">Please select date. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="latestOilChangedMileage" nzRequired>Last Oil Change Mileage</nz-form-label>
            <nz-form-control [nzErrorTip]="latestOilChangedMileageError">
              <nz-input-group nzAddOnAfter="Km">
                <input nz-input type="number" [min]="0" [step]="1" formControlName="latestOilChangedMileage" placeholder="Enter Last Change Mileage"/>
              </nz-input-group>
<!--              <nz-input-number-->
<!--                class="w-full"-->
<!--                formControlName="latestOilChangedMileage"-->
<!--                nzPlaceHolder="Enter Last Change Mileage"-->
<!--                [nzMin]="0"-->
<!--                [nzStep]="1"-->
<!--                [nzFormatter]="formatterDistance"-->
<!--                [nzParser]="parserDistance"-->
<!--              ></nz-input-number>-->
<!--              <input nz-input type="number" formControlName="latestOilChangedMileage"-->
<!--                     placeholder="Enter Last Change Mileage"/>-->
            </nz-form-control>
            <ng-template #latestOilChangedMileageError>
              <span
                *ngIf="formErrors.vehicleInventoryInfo.latestOilChangedMileage.required">Please enter mileage. </span>
              <span
                *ngIf="formErrors.vehicleInventoryInfo.latestOilChangedMileage.maxlength">Maximum 15 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="oilChangeDuration" nzRequired>Oil Change Duration (40'000km)</nz-form-label>
            <nz-form-control [nzErrorTip]="oilChangeDurationError">
              <nz-input-group nzAddOnAfter="Km">
                <input nz-input type="number" [min]="0" [step]="1" formControlName="oilChangeDuration" placeholder="Enter Change Duration"/>
              </nz-input-group>
<!--              <nz-input-number-->
<!--                class="w-full"-->
<!--                formControlName="oilChangeDuration"-->
<!--                nzPlaceHolder="Enter Change Duration"-->
<!--                [nzMin]="0"-->
<!--                [nzStep]="1"-->
<!--                [nzFormatter]="formatterDistance"-->
<!--                [nzParser]="parserDistance"-->
<!--              ></nz-input-number>-->
<!--              <input nz-input type="number" formControlName="oilChangeDuration"-->
<!--                     placeholder="Enter Change Duration"/>-->
            </nz-form-control>
            <ng-template #oilChangeDurationError>
              <span *ngIf="formErrors.vehicleInventoryInfo.oilChangeDuration.required">Please enter duration. </span>
              <span *ngIf="formErrors.vehicleInventoryInfo.oilChangeDuration.maxlength">Maximum 15 letters only. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-between">
            <nz-form-label nzFor="oilChangeResponsible" nzRequired>Oil Change will be done by?</nz-form-label>
            <nz-form-control [nzErrorTip]="oilChangeResponsibleError">
              <nz-select class="w-full" formControlName="oilChangeResponsible"
                         nzPlaceHolder="Select Who Will Be">
                <nz-option nzValue="SR" nzLabel="SR"></nz-option>
                <nz-option nzValue="OWNER" nzLabel="Vehicle Owner"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #oilChangeResponsibleError>
              <span *ngIf="formErrors.vehicleInventoryInfo.oilChangeResponsible.required">Please select value. </span>
            </ng-template>
          </nz-form-item>
        </div>
      </form>
    </div>


    <div *ngIf="fleetForm.get('generalInfo').get('vehicleType').value" class="mt-10">
      <h5 class="text-primary my-4">Other Details</h5>
<!--      <h6 class="my-2 text-red-700">Note : If the Insurance type is already not a "Rent a Car Insurance", it should be change to a-->
<!--        "Rent a Car Insurance" within 2 months"</h6>-->
      <div class="md:col-span-2 pb-3">
        <nz-alert style="display: inline-block;"  nzType="info" nzMessage="If the Insurance type is already not a 'Rent a Car Insurance', it should be change to a
        'Rent a Car Insurance' within 2 months" class="mb-3 custom-alert" nzShowIcon></nz-alert>
      </div>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="otherInfo">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="insuranceName" nzRequired>Insurance Company Name</nz-form-label>
            <nz-form-control [nzErrorTip]="insuranceNameError">
              <input nz-input type="text" formControlName="insuranceName" placeholder="Enter Insurance Company Name"/>
            </nz-form-control>
            <ng-template #insuranceNameError>
              <span *ngIf="formErrors.otherInfo.insuranceName.required">Please enter name. </span>
              <span *ngIf="formErrors.otherInfo.insuranceName.maxlength">Maximum 70 letters only. </span>
              <span *ngIf="formErrors.otherInfo.insuranceName.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="insuranceType" nzRequired>Insurance Type</nz-form-label>
            <nz-form-control [nzErrorTip]="insuranceTypeError">
              <nz-select class="w-full" formControlName="insuranceType" nzPlaceHolder="Select Type of Insurance">
                <nz-option nzValue="RENT" nzLabel="Rent a Car Insurance"></nz-option>
                <nz-option nzValue="HIRING" nzLabel="Hiring Insurance"></nz-option>
                <nz-option nzValue="PRIVATE" nzLabel="Private Insurance"></nz-option>
                <nz-option nzValue="OTHER" nzLabel="Other Insurance"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #insuranceTypeError>
              <span *ngIf="formErrors.otherInfo.insuranceName.required">Please select type. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="insuranceExpDate" nzRequired>Insurance Expiry Date</nz-form-label>
            <nz-form-control [nzErrorTip]="insuranceExpDateError">
              <nz-date-picker formControlName="insuranceExpDate" class="w-full"></nz-date-picker>
            </nz-form-control>
            <ng-template #insuranceExpDateError>
              <span *ngIf="formErrors.otherInfo.insuranceExpDate.required">Please select date. </span>
            </ng-template>
          </nz-form-item>
        </div>
      </form>

      <nz-divider></nz-divider>

      <div class="grid xl:grid-cols-2 gap-2">
        <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
          <div class="grid sm:grid-cols-2 gap-2" formGroupName="otherInfo">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="ecoTestExpDate" nzRequired>Eco Test Expiry Date</nz-form-label>
              <nz-form-control [nzErrorTip]="ecoTestExpDateError">
                <nz-date-picker formControlName="ecoTestExpDate" class="w-full"></nz-date-picker>
              </nz-form-control>
              <ng-template #ecoTestExpDateError>
                <span *ngIf="formErrors.otherInfo.ecoTestExpDate.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="revenueLicenceExpDate" nzRequired>Revenue Licence Expiry Date</nz-form-label>
              <nz-form-control [nzErrorTip]="revenueLicenceExpDateError">
                <nz-date-picker formControlName="revenueLicenceExpDate" class="w-full"></nz-date-picker>
              </nz-form-control>
              <ng-template #revenueLicenceExpDateError>
                <span *ngIf="formErrors.otherInfo.revenueLicenceExpDate.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
            <div *ngIf="!sectionHideByVehicleType">
              <span nz-checkbox formControlName="isLeasedVehicle" class="mb-4">The Vehicle is a Leased Vehicle</span>
              <nz-form-item *ngIf="isLeasedVehicle" class="grid grid-flow-row content-start">
                <nz-form-label nzFor="leaseComName" nzRequired>Bank / Leading Company Name</nz-form-label>
                <nz-form-control [nzErrorTip]="leaseComNameError">
                  <input nz-input type="text" formControlName="leaseComName"
                         placeholder="Enter Bank / leasing Company Name"/>
                </nz-form-control>
                <ng-template #leaseComNameError>
                  <span *ngIf="formErrors.otherInfo.leaseComName.required">Please enter name. </span>
                  <span *ngIf="formErrors.otherInfo.leaseComName.maxlength">Maximum 70 letters only. </span>
                  <span *ngIf="formErrors.otherInfo.leaseComName.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>
        </form>
        <div>
          <h6>Attachments</h6>
          <div class="mb-3 my-2">Insurance, Revenue License & Eco Test Certificate</div>
          <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
            <div>
              <nz-upload
                [nzCustomRequest]="vehicleOtherInfoUpload" [nzShowUploadList]="false" [nzMultiple]="true">
                <button nz-button>
                  <span nz-icon nzType="upload"></span>
                  Click to Upload
                </button>
              </nz-upload>
            </div>
            <div>
              <p *ngIf="vehicleOtherInfoUploading" class="text-primary my-2">Uploading...</p>
            </div>
            <div class="mt-2 overflow-auto">
              <div *ngFor="let file of vehicleOtherInfoUploadFiles; let i = index"
                   class="flex justify-between items-center mx-3 gap-5">
                <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                      class="cursor-pointer" nz-popconfirm
                      nzPopconfirmTitle="Are you sure you want to delete this attachment"
                      (nzOnConfirm)="removeUploadFile(i, 'other_details')"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="fleetForm.get('generalInfo').get('vehicleType').value && !sectionHideByVehicleType" class="mt-10">
      <h5 class="text-primary my-4">Payment Details</h5>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="paymentInfo">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="paymentMethod" nzRequired>Payment Method</nz-form-label>
            <nz-form-control [nzErrorTip]="paymentMethodError">
              <nz-select class="w-full" formControlName="paymentMethod" nzPlaceHolder="Select Payment Method">
                <nz-option nzValue="TRANSFER" nzLabel="Bank Transfer"></nz-option>
                <nz-option nzValue="ONLINE" nzLabel="Online Payment"></nz-option>
                <nz-option nzValue="CASH" nzLabel="Cash"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #paymentMethodError>
              <span *ngIf="formErrors.paymentInfo.paymentMethod.required">Please select method. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="bankName" nzRequired>Bank Name</nz-form-label>
            <nz-form-control [nzErrorTip]="bankNameError">
              <input nz-input type="text" formControlName="bankName" placeholder="Enter Bank Name"/>
            </nz-form-control>
            <ng-template #bankNameError>
              <span *ngIf="formErrors.paymentInfo.bankName.required">Please enter name. </span>
              <span *ngIf="formErrors.paymentInfo.bankName.maxlength">Maximum 70 letters only. </span>
              <span *ngIf="formErrors.paymentInfo.bankName.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="branchName" nzRequired>Branch Name</nz-form-label>
            <nz-form-control [nzErrorTip]="branchNameError">
              <input nz-input type="text" formControlName="branchName" placeholder="Enter Branch Name"/>
            </nz-form-control>
            <ng-template #branchNameError>
              <span *ngIf="formErrors.paymentInfo.branchName.required">Please enter name. </span>
              <span *ngIf="formErrors.paymentInfo.branchName.maxlength">Maximum 70 letters only. </span>
              <span *ngIf="formErrors.paymentInfo.branchName.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
            </ng-template>
          </nz-form-item>
        </div>
      </form>
      <form nz-form [formGroup]="fleetForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="paymentInfo">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="accountType" nzRequired>Account Type</nz-form-label>
            <nz-form-control [nzErrorTip]="accountTypeError">
              <nz-select class="w-full" formControlName="accountType" nzPlaceHolder="Select Account Type">
                <nz-option nzValue="SAVING" nzLabel="Saving"></nz-option>
                <nz-option nzValue="CURRENT" nzLabel="Current"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #accountTypeError>
              <span *ngIf="formErrors.paymentInfo.accountType.required">Please select type. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="accountHolder" nzRequired>Account Holder Name</nz-form-label>
            <nz-form-control [nzErrorTip]="accountHolderError">
              <input nz-input type="text" formControlName="accountHolder" placeholder="Enter Account Holder Name"
                     (focus)="accHolderNameChange()"/>
            </nz-form-control>
            <ng-template #accountHolderError>
              <span *ngIf="formErrors.paymentInfo.accountHolder.required">Please enter name. </span>
              <span *ngIf="formErrors.paymentInfo.accountHolder.maxlength">Maximum 70 letters only. </span>
              <span *ngIf="formErrors.paymentInfo.accountHolder.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="accountNumber" nzRequired>Account Number</nz-form-label>
            <nz-form-control [nzErrorTip]="accountNumberError">
              <input nz-input type="text" formControlName="accountNumber" placeholder="Enter Account Number"/>
            </nz-form-control>
            <ng-template #accountNumberError>
              <span *ngIf="formErrors.paymentInfo.accountNumber.required">Please enter number. </span>
              <span *ngIf="formErrors.paymentInfo.accountNumber.maxlength">Maximum 70 letters only. </span>
              <span *ngIf="formErrors.paymentInfo.accountNumber.pattern">Only allowed Numbers, please avoid adding special characters or letters. </span>
            </ng-template>
          </nz-form-item>
        </div>
      </form>
      <nz-divider></nz-divider>

      <div class="grid xl:grid-cols-2 gap-2">
        <div>
          <h6>Attachments</h6>
          <div class="mb-2">Bank Details</div>
          <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
            <div>
              <nz-upload
                [nzCustomRequest]="bankInfoUpload" [nzShowUploadList]="false" [nzMultiple]="true"
                class="">
                <button nz-button>
                  <span nz-icon nzType="upload"></span>
                  Click to Upload
                </button>
              </nz-upload>
            </div>
            <div>
              <p *ngIf="bankInfoUploading" class="text-primary my-2">Uploading...</p>
            </div>
            <div class="mt-2 overflow-auto">
              <div *ngFor="let file of bankInfoUploadFiles; let i = index"
                   class="flex justify-between items-center mx-3 gap-5">
                <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                      class="cursor-pointer" nz-popconfirm
                      nzPopconfirmTitle="Are you sure you want to delete this attachment"
                      (nzOnConfirm)="removeUploadFile(i, 'payment')"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end mt-10">
      <button class="outline-button mr-3" nz-button nzType="default" nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to cancel this fleet? You will lost all data."
              [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnConfirm)="fleetCancel()"
      >Cancel
      </button>
      <button nz-button nzType="primary" nz-popconfirm
              nzPopconfirmTitle="{{fleetId ? 'Are you sure you want to save this information' : 'Are you sure you want to add new vehicle?'}}"
              [nzOkText]="'Yes'" [nzCancelText]="'No'" [disabled]="fleetForm.invalid"
              (nzOnConfirm)="submit()">Update Vehicle</button>
    </div>
    <nz-alert *ngIf="actionMessage.display" class="mt-2" [nzType]="actionMessage.type"
              [nzMessage]="actionMessage.message" nzShowIcon></nz-alert>


  </nz-card>
</section>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>

